function roundToNearest(num: number, bucketSize: number): number {
  return Math.floor(Math.ceil(num / bucketSize) * bucketSize);
}

const widthScaleToNearestBucket = (
  [oldWidth, oldHeight]: readonly [number, number],
  bucketSize: number
): [number, number] => {
  const newWidth = roundToNearest(oldWidth, bucketSize);
  const newHeight = Math.ceil(oldHeight * (newWidth / oldWidth)); // Based on width
  return [newWidth, newHeight];
};

const heightScaleToNearestBucket = (
  [oldWidth, oldHeight]: readonly [number, number],
  bucketSize: number
): [number, number] => {
  const newHeight = roundToNearest(oldHeight, bucketSize);
  const newWidth = Math.ceil(oldWidth * (newHeight / oldHeight)); // Based on height
  return [newWidth, newHeight];
};

export function roundAndScale([oldWidth, oldHeight]: readonly [number, number], bucketSize: number): [number, number] {
  return oldWidth > oldHeight
    ? widthScaleToNearestBucket([oldWidth, oldHeight], bucketSize)
    : heightScaleToNearestBucket([oldWidth, oldHeight], bucketSize);
}
